module.exports = __webpack_public_path__ + "img/资产负债_试算平衡3.e665bb6b.png";